import { directPaymentApi } from "../config/apiConfig";

export const getAllQrCodeUrls = async () => {
	try {
		const response = await directPaymentApi.get("qr/list");
		return response.data;
	} catch (error) {
		console.error("Error fetching QR code URLs:", error);
		throw error;
	}
}

export const assignTargetIdToQrCode = async (qrCodeUrl, targetId, isLocation) => {
	try {
		const response = await directPaymentApi.put("qr/assign", {
			qrCodeUrl: qrCodeUrl,
			targetId: targetId,
			isLocation: isLocation,
		});
		return response.data;
	} catch (error) {
		console.error("Error assigning EVSE to QR code:", error);
		throw error;
	}
}

export const unassignQrCode = async (qrCodeUrl) => {
	try {
		const response = await directPaymentApi.put("qr/unassign", {
			qrCodeUrl: qrCodeUrl,
		});
		return response.data;
	} catch (error) {
		console.error("Error unassigning QR code:", error);
		throw error;
	}
}

export const generateQrCodeUrls = async (quantity) => {
	try {
		const response = await directPaymentApi.post("qr/generate", {
			quantity: quantity,
		});
		return response.data;
	} catch (error) {
		console.error("Error generating QR code URLs:", error);
		throw error;
	}
}